import * as React from 'react';
import { connect } from 'react-redux';
import { setQuoteType, initiateCodeRedSteps, initiateWarrantySteps, resetQuoteData, initiateBuildingSteps, initiateHomeContentSteps } from '../../actions/salesActions';
import { navigateTo } from '../../actions/navigationActions';
import { signInAnon } from '../../actions/authActions';
import { logEvent } from '../../firebase/firebase';
import { PRODUCT_BUILDING, PRODUCT_CAR_WARRANTY, PRODUCT_CODE_RED, PRODUCT_COMPREHENSIVE_CAR, PRODUCT_HOME_CONTENT} from '../../constants/constants';
import { BUILDING_AND_CONTENT_JOURNEY_BUILDER, CODE_RED_VIEW_BUILDER, DASHBOARD, PERSONAL_INFO, WARRANTY_JOURNEY_BUILDER } from '../../routes/routes';
import { showAddNewItem } from '../../actions/modalActions';

class GuestQuote extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {};

        this.handleSetProduct = this.handleSetProduct.bind(this);
    }

    componentDidMount() {
        logEvent('SSP_guest_quote_landing_page', 'user_landed_on_page');
        let product = this.props.match.params.product?.toString().toLowerCase() ?? '';
        this.handleSetProduct(product);
    }

    async handleSetProduct(product: any) {
        await this.props.dispatchAction(signInAnon(false, false));
        this.props.dispatchAction(resetQuoteData());

        let navigateToDashboard = false;
        switch (product) {
            case 'car':
                await this.props.dispatchAction(setQuoteType(PRODUCT_COMPREHENSIVE_CAR));
                this.props.dispatchAction(navigateTo(PERSONAL_INFO));
                break;
            case 'carwarranty':
                await this.props.dispatchAction(setQuoteType(PRODUCT_CAR_WARRANTY));
                await this.props.dispatchAction(initiateWarrantySteps());
                this.props.dispatchAction(navigateTo(WARRANTY_JOURNEY_BUILDER));
                break;
            case 'codered':
                await this.props.dispatchAction(setQuoteType(PRODUCT_CODE_RED));
                await this.props.dispatchAction(initiateCodeRedSteps());
                this.props.dispatchAction(navigateTo(CODE_RED_VIEW_BUILDER));
                break;
            case 'buildings':
                await this.props.dispatchAction(setQuoteType(PRODUCT_BUILDING));
                await this.props.dispatchAction(initiateBuildingSteps());
                this.props.dispatchAction(navigateTo(BUILDING_AND_CONTENT_JOURNEY_BUILDER));
                break;
            case 'homecontent':
                await this.props.dispatchAction(setQuoteType(PRODUCT_HOME_CONTENT));
                await this.props.dispatchAction(initiateHomeContentSteps());
                this.props.dispatchAction(navigateTo(BUILDING_AND_CONTENT_JOURNEY_BUILDER));
                break;
            default:
                navigateToDashboard = true;
        }

        if (navigateToDashboard) {
            this.props.dispatchAction(navigateTo(DASHBOARD));
            this.props.dispatchAction(showAddNewItem());
        }
    }

    public render () {
        return (
            <div></div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {}
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestQuote);